import styled from 'styled-components'
import COLORS from '@colors'

export const Container = styled.div`
  width: 100%;
  max-width: 1360px;
  cursor: ${({ isLoading }) => (isLoading ? 'progress' : 'default')};
`

export const TableWrapper = styled.div`
  overflow-x: auto;
`

export const Table = styled.div`
  margin: 0 auto;
  max-width: 1360px;
  min-width: 1015px;
`

export const Row = styled.div`
  width: 100%;
  padding: 16px;
  padding-left: 26px;
  display: flex;
  border-radius: 4px;
  box-shadow: ${props => (props.header ? 'none' : '0px 3px 8px #0000001a')};
  background-color: ${props => (props.header ? 'transparent' : COLORS.white)};
  color: ${COLORS.gray45};
  margin-bottom: 8px;
  height: 52px;
  ${props =>
    props.header &&
    `
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    user-select: none;
    height: 64px;
    padding-right: 22px;
  `}
  ${props =>
    props.alignEnd &&
    `
    justify-content: flex-end;
  `}
  @media (min-width: 1360px) {
    width: 1352px;
  }
`

export const ContentColumn = styled.div`
  width: calc(100% - 56px);
  display: flex;
`

export const Column = styled.div`
  width: ${({ columnWidth }) => `${columnWidth || 9.28}%`};
  padding-left: 5px;
  text-align: center;

  ${({ header }) =>
    header
      ? `
    display: flex;
    padding-right: 10px;
    align-items: center;
    justify-content: center;
    svg {
      margin-right: 3px;
    }
  `
      : `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right:5px;
  `}
  ${({ color }) => color && `color: ${color}`}
`

export const Option = styled.div`
  display: flex;
  align-items: center;
  margin-right: 21px;
  font-size: 14px;
  line-height: 14px;
  cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
  text-transform: none;
  user-select: none;

  svg {
    margin-right: 10px;
  }
`

export const Scroll = styled.div`
  max-height: calc(100vh - 350px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${COLORS.whiteF3};
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.whiteD};
  }

  @media (min-width: 1360px) {
    width: 1360px;
  }
`

export const IconWrapper = styled.div`
  height: ${props => (props.more ? '24px' : props.search ? '18px' : '16px')};
  width: ${props => (props.more ? '24px' : props.search ? '18px' : '16px')};
  ${props => (props.more ? 'margin-left: 8px' : 'margin-right: 8px')};
  cursor: pointer;
  user-select: none;
  ${props => props.search && 'margin-top: 7px;'}
`

export const GadgetsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Button = styled.button`
  border: 1px solid ${COLORS.whiteA1};
  border-radius: 4px;
  color: ${COLORS.gray45};
  cursor: pointer;
  user-select: none;
  outline: 0;
  width: ${props => (props.pdf ? '132px' : '144px')};
  height: 32px;
  background-color: transparent;
  ${props => props.pdf && 'margin-right: 24px'};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 8px;
  }
`

export const Input = styled.input`
  border: 0;
  color: ${COLORS.whiteA1};
  width: 135px;
  background-color: transparent;
  margin-left: 7px;
  margin-right: 24px;
  height: 32px;
  outline: 0;
`

export const Text = styled.p`
  margin-left: ${({ noMargin, dropdown }) => {
    if (noMargin) {
      return 'unset'
    }
    return dropdown ? '3px' : '14px'
  }};
  ${props => props.dropdown && 'margin-right: 7px;'}
`

export const AdUrl = styled.a`
  :visited,
  :hover {
    color: ${COLORS.leather};
  }
`
